import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({ standalone: false,
  selector: 'vfa-cp-error404',
  templateUrl: './error404.component.html'
})
export class Error404Component {
  constructor(public router: Router) {}
}

